<div class="loading__item" [class.transparent]="bgTransparent">
    <mat-spinner [diameter]="25"></mat-spinner>
</div>
